import { useReducer } from "react";
import { TokensPayload } from "src/hooks/useAuth";

export const initial: State = {
	isAuthenticated: false,
	isInitialized: false,
	token: null,
	refreshToken: null
};

export interface State {
	isAuthenticated: boolean;
	isInitialized: boolean;
	token: string | null;
	refreshToken: string | null;
}

enum ActionType {
	init = "init",
	signIn = "signIn",
	signOut = "signOut"
}

interface Action {
	type: string;
	val: TokensPayload | undefined;
}

function reducer(state: State, action: Action): State {
	switch (action.type) {
		case ActionType.init:
			const initState = {
				...state,
				isInitialized: true
			};
			localStorage.setItem("authState", JSON.stringify(initState));
			return initState;
		case ActionType.signIn:
			const val = action.val as TokensPayload;
			const signInState = {
				isInitialized: true,
				isAuthenticated: true,
				token: val.token,
				refreshToken: val.refreshToken
			};
			localStorage.setItem("authState", JSON.stringify(signInState));
			return signInState;
		case ActionType.signOut:
			const signOutState = {
				isAuthenticated: false,
				isInitialized: true,
				token: null,
				refreshToken: null
			};
			localStorage.setItem("authState", JSON.stringify(signOutState));
			return signOutState;
		default:
			throw new Error("action type not found");
	}
}

export default function useAuthStore() {
	const [state, dispatch] = useReducer(reducer, initial);

	const actions = {
		init: () => {
			return dispatch({ type: ActionType.init, val: undefined });
		},
		signIn: (val: TokensPayload) => {
			return dispatch({ type: ActionType.signIn, val });
		},
		signOut: () => dispatch({ type: ActionType.signOut, val: undefined })
	};

	return [state, actions] as const;
}
